import { getCookie } from 'cookies-next/client';

import { VARIANT_IDENTIFIER } from './config';
import { COMBINED_FLOW_COOKIE_VALUE } from './helpers/setCombinedFlowCookie';
import { useExperiments } from './useExperiments';

import { COMBINED_FLOW_LAYOUT } from '@/constants/cookies';

export function useIsCombinedFlowVariant() {
  const [{ web_8810_combined_signup_checkout }] = useExperiments(
    ['web_8810_combined_signup_checkout'],
    { deferred: true }
  );

  return (
    getCookie(COMBINED_FLOW_LAYOUT) === COMBINED_FLOW_COOKIE_VALUE &&
    web_8810_combined_signup_checkout === VARIANT_IDENTIFIER
  );
}
